<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Oasis_Field_Url')"
        prop="params.url"
        :hint="$t('Integrations_Oasis_Field_Url_Hint')"
      >
        <el-input v-model="model.params.url" placeholder="https://" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Oasis_Field_ApiKey')"
        prop="params.api_key"
        :hint="$t('Integrations_Oasis_Field_ApiKey_Hint')"
      >
        <el-input
          v-model="model.params.api_key"
          :placeholder="$t('Integrations_Oasis_Field_ApiKey')"
        />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'OasisSettings',
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  components: {
    FormSection,
    RestFormItem
  },
  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          url: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          api_key: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/oasis/OasisSettings.vue